<template>
  <div class="bcWarp">
    <div class="inner">
      <div class="title">
        <img src="../assets/img/xstm.png" />
      </div>
      <h2>幸运靶场</h2>
      <ul class="bc">
        <li
          v-for="(item,index) in bcData.rangeList"
          :key="index"
        >
          <img
            :src="getImg(item,'bc')"
            alt=""
          >
          <p class="dates">{{bcData.Date}}</p>
          <p class="names">{{item}}</p>
        </li>
      </ul>
      <!--jx2 jx3-->
      <dl class="jx">
        <dd
          v-for="(item,index) in jxData.jxList"
          :key="index"
        >
          <img
            :src="getImg(item,'jx')"
            alt=""
          >
          <p>{{item}}</p>
        </dd>

        <dt class="jx-date">{{jxData.Date}}</dt>
      </dl>
    </div>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "versionBc",
  data() {
    return {
      // bc=>靶场 jx=>军需  **每次更新只需换下面数据** ImgSrc为图片名字拼音...
      bcImgMap: [
        //正在拓展src的地址 后续使用
        { name: "弑血虫群核心模块", src: "sxcqsp" },
        { name: "神器碎片", src: "sqsp" },
        { name: "弑血虫群-孵化", src: "bc-sxcq" },
        { name: "移动装置（永久）", src: "bc-ydzz" },
        { name: "便携手雷包（永久）", src: "bxslb" },
        { name: "圣诞老人的袜子", src: "sdw" },
        { name: "体质增强器III型以小搏大包", src: "tzzqq3" },
        { name: "破片过滤网（永久）", src: "bc-ppglw" },
        { name: "医疗装置III型以小搏大包", src: "ylzz3" },
        { name: "移动装置III型以小搏大包", src: "ydzz3" },
        { name: "力量增幅器III型以小搏大包", src: "llzfq3" },
        { name: "啪啪啪的雪球", src: "papapa" },
        { name: "体质增强器（永久）", src: "tzzqq" },
        { name: "落日燎原核心模块", src: "mrlymk" },
        { name: "丘比特之箭（永久）", src: "qbtzj" },
        { name: "愚者无畏（名片）", src: "yzww" },
        {
          name: "春花水暖辞旧岁（永久）、一枪倾心（名片）（永久）",
          src: "chsnyqqx"
        },
        {
          name:
            "百发百中核心模块、毁灭镭射核心模块、闪电枷锁核心模块、连珠炮核心模块",
          src: "4hexin"
        },
        {
          name:
            "地狱浩劫核心模块、碎星炮核心模块、毒液之牙核心模块、疾雨流星核心模块",
          src: "4mk"
        },
        {
          name:
            "苍穹回响核心模块、毁灭之轮核心模块、不灭冷焰核心模块、寒霜先锋核心模块",
          src: "4mk"
        },
        { name: "自动装填装置（永久）", src: "zdtzzz" },
        { name: "圣诞快乐（名片）", src: "sdmp" },
        { name: "供弹器III型以小搏大包", src: "gdq3" },
        { name: "破片过滤网III型以小搏大包", src: "bc-ppglw" },
        { name: "新年快乐（名片）", src: "xnkl" },

        { name: "鎏金骑士碎片（蓝、紫、橙）", src: "ljqs" },
        { name: "毒液之牙碎片", src: "dyzy" },
        { name: "天元地宵赏花灯（永久）", src: "tydx" },
        { name: "超能-毁灭之轮（3/7天）概率翻五倍", src: "bc-cnhmzl" },
        { name: "超能-毁灭之轮（3天/7天）", src: "bc-cnhmzl" },
        { name: "暴君-原始咆哮（3/7天）概率翻五倍", src: "bc-yspx" },
        { name: "超能-毁灭镭射（3/7天）概率翻五倍", src: "bc-hmls" },
        { name: "毁灭者专属材料、冻结者专属材料", src: "djhm" }

      ],
      jxImgMap: [
        //正在拓展src的地址 后续使用
        { name: "死亡之翼时空箱（稀有）", src: "swzyskx" },
        { name: "炼狱挽歌（30天）", src: "lywg" },
        { name: "X战机时空箱（稀有）", src: "jx-xzjskx" },
        { name: "圣诞老人的袜子", src: "jxsdw" },
        { name: "无尽P90（永久）", src: "wjp90" },
        { name: "啪啪啪的雪球", src: "pax" },
        { name: "离子先锋时空箱（稀有）", src: "jx-lzxf(xy)" },
        { name: "天空杀手时空箱（稀有）", src: "jx_tk" },
        { name: "歼星巨龙时空箱（稀有）", src: "jx-jxjl" },
        { name: "泰山G36（永久）", src: "g36" },
        { name: "无尽RPD（永久）", src: "jx-wjrpd" },
        { name: "炎龙Barret M82（永久）", src: "jx-ylm82" },
        { name: "鹰眼PP-19 Bizon（永久）", src: "jx-yypp" },
        { name: "设计图：晶能电源 Mk.6", src: "jx-sjt(jndy)" }
      ]
    };
  },
  computed: {
    ...mapGetters(["bcData", "jxData"])
  },
  created() {
    console.log("bc_created");
  },
  mounted() {
    console.log("bc_mounted");
  },
  methods: {
    getImg(name, type) {
      var src = "",
        searchArr = [];
      if (type === "bc") {
        searchArr = this.bcImgMap;
      } else if (type === "jx") {
        searchArr = this.jxImgMap;
      }
      searchArr.forEach(function(val) {
        if (name.indexOf(val.name) !== -1) {
          src = val.src;
        }
      });

      if (!src) {
        console.log(name);
      } else {
        return require("../assets/img/" + type + "/" + src + ".png");
      }
    } //用require编译图片地址  之后可能放在static 文件下
  }
};
</script>

<style lang="scss" scoped>
.inner {
  width: 1200px;
  margin: 0 auto;
  padding-top: 1px;
}
.bcWarp {
  background: url("../assets/img/bg5.jpg") no-repeat top center;
  height: 1001px;
  position: relative;
  min-width: 1200px;
  .title {
    padding-top: 66px;
    position: relative;
  }
  h2 {
    color: #ffdb8d;
    font-size: 42px;
    margin-left: 508px;
    text-align: left;
  }
  .bc {
    padding-top: 28px;
    height: 297px;
    li {
      padding-right: 20px;
      width: 280px;
      height: 297px;
      float: left;
      position: relative;
      img {
        display: inline-block;
        margin-top: 121px;
        margin-left: 20px;
        width: 259px;
        height: 131px;
      }
      .dates {
        font-size: 14px;
        color: #ffd98a;
        position: absolute;
        top: 39px;
        left: 59px;
      }
      .names {
        font-size: 14px;
        color: #ffc958;
        position: absolute;
        top: 257px;
        left: 24px;
        width: 256px;
        text-align: center;
      }
    }
    li:nth-child(1) {
      background: url("../assets/img/zs-bc.png") no-repeat;
      height: 309px;
      p {
        color: #64baff;
      }
    }
    li:nth-child(2) {
      background: url("../assets/img/bc-1.png") no-repeat;
      p {
        color: #ffd98a;
      }
    }
    li:nth-child(3) {
      background: url("../assets/img/bc-2.png") no-repeat;
      p {
        color: #f0d743;
      }
    }
    li:nth-child(4) {
      background: url("../assets/img/bc-3.png") no-repeat;
      p {
        color: #d0d0d0;
      }
    }
  }
  .jx {
    width: 964px;
    height: 305px;
    margin-top: 47px;
    margin-left: 110px;
    background: url("../assets/img/jx.png") no-repeat;
    position: relative;
    dd {
      float: left;
      width: 442px;
      padding: 75px 20px 0 20px;
      color: #28cac4;
      font-size: 18px;
      img {
        display: inline-block;
        width: 302px;
        height: 175px;
      }
    }
    dt {
      color: #28cac4;
      font-size: 16px;
      position: absolute;
      top: 47px;
      left: 365px;
    }
  }
}
</style>
















// WEBPACK FOOTER //
// src/components/qqsmVersion_bc.vue